import { TagChips } from "@msys/ui";
import { BoxProps } from "@mui/material";
import React from "react";
import { isTagReserved, useReservedTagLabels } from "./useReservedTagLabels.js";

interface Props {
  tags: string[];
  wrap?: boolean;
  boxProps?: BoxProps;
}

export const CrmTagChips = ({ tags, wrap = true, boxProps }: Props) => {
  const { reservedTagLabels } = useReservedTagLabels();
  return (
    <TagChips
      tags={tags.map(tag =>
        isTagReserved(tag) ? reservedTagLabels[tag] : tag
      )}
      wrap={wrap}
      boxProps={boxProps}
    />
  );
};
